<template>
  <div class="base-footer">
    <div class="w1200" v-if="lang == 'zh'">
     <span @click="goPrivacy" style="cursor:pointer">隐私政策</span>
      <span>版权所有</span>                                              
<h5>Copyright ©爱士惟科技股份有限公司 All Rights Reserved</h5>
      <span class="fr">沪ICP备2022021275号-1</span>
    </div>
    <div class="w1200" v-else>
        <span @click="goPrivacy" style="cursor:pointer">Privacy</span>     
        <span>Imprint</span>       
        <span @click="goISO('1')" style="cursor:pointer">ISO 9001</span>     
        <span @click="goISO('2')" style="cursor:pointer">ISO 14001</span>                                            
<h5>Copyright © AISWEI Technology Co., Ltd.</h5>
      <span class="fr">沪ICP备2022021275号-1</span>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
  },
  data() {
    return {
      lang: 'zh'
    }
  },
  methods: {
    goPrivacy() {
      location.href = 'https://www.aiswei-tech.com/banquan/1.html';
    },
    goISO(type) {
      if (type === '1') {
        window.open('http://cetest01.ufile.ucloud.com.cn/100001_1905175114/ISO_9001_EN1568708189824.pdf');
      } else {
        window.open('http://cetest01.ufile.ucloud.com.cn/100001_1905175114/ISO_14001_EN1568708208948.pdf');
      }
    }
  },
  created() {
    this.lang = window.localStorage.getItem('localeLanguage') || 'zh'
  }
}
</script>
<style lang="stylus">
.base-footer
  background #fff
  border-top 1px solid #dadada
  .w1200
    position relative
    height 35px
    line-height 35px
    padding 0 75px
    z-index 2
    color #999
    span
      float left
      margin-right 25px
      font-size 12px
    h5
      text-align center
      margin 0 auto
      width 450px
      font-size 12px
    .fr
      position absolute
      right 0
      bottom 0 
      font-size 12px  
</style>


// WEBPACK FOOTER //
// src/modules/baseFooter/index.vue